import {
  SET_INITIALISED,
  SET_AWAITING_CALCULATION,
  SET_DATA,
  SET_ERROR,
  SET_STEP,
  SET_FINANCE_OPTION,
  SET_FORM_VALUES,
  SET_MAKES,
  SET_DEALERS,
  SET_SUBSTEP,
  SET_LOADED_CONFIGURATION,
  SET_CALCULATIONS,
  SET_FINANCE_PROVIDER_URL,
} from './types';

export const setInitialised = () => ({
  type: SET_INITIALISED,
});

export const setAwaitingCalculation = (payload = true) => ({
  type: SET_AWAITING_CALCULATION,
  payload,
});

export const setData = payload => ({
  type: SET_DATA,
  payload,
});

export const setError = payload => ({
  type: SET_ERROR,
  payload,
});

export const setStep = payload => ({
  type: SET_STEP,
  payload,
});

export const setFinanceOption = payload => ({
  type: SET_FINANCE_OPTION,
  payload,
});

export const setFormValues = payload => ({
  type: SET_FORM_VALUES,
  payload,
});

export const setMakes = payload => ({
  type: SET_MAKES,
  payload,
});

export const setDealers = payload => ({
  type: SET_DEALERS,
  payload,
});

export const setSubstep = payload => ({
  type: SET_SUBSTEP,
  payload,
});

export const setLoadedConfiguration = payload => ({
  type: SET_LOADED_CONFIGURATION,
  payload,
});

export const setCalculations = payload => ({
  type: SET_CALCULATIONS,
  payload,
});

export const setFinanceProviderUrl = payload => ({
  type: SET_FINANCE_PROVIDER_URL,
  payload,
});
